export const normalizeApiError = (error, fallback = "An error occurred. Please try again.") => {
    const status = error?.response?.status || error?.status || null;
    const code = error?.code || error?.response?.data?.code || null;
    const details = error?.response?.data || error?.data || null;

    const message =
    error?.response?.data?.error ||
    error?.response?.data?.message ||
    error?.response?.data?.title ||
    (typeof error?.message === "string" && error.message.trim() ? error.message : "") ||
    fallback;

    return {
        message,
        status,
        code,
        details,
        raw: error,
    };
};

export const getErrorMessage = (error, fallback = "An error occurred. Please try again.") =>
    normalizeApiError(error, fallback).message;
